import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useNasGroup from "../../../../hooks/useNasGroup";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import FilterReset from "../../../../components/FilterReset";
import { searchPayload, convertedValue } from "../../../../utils/common";
import { OperatorConstants } from "../../../../constants/operator.constants";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import CustomTextField from "../../../../components/CustomTextField";
import { useDialog } from "../../../../contexts/DialogContext";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const statusOptions = [
  {
    label: "Active",
    value: "A",
  },
  {
    label: "InActive",
    value: "INA",
  },
];

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialValues = {
    nasGroupNameOperator: "eq",
    statusOperator: "eq",
    nasGroupName: [],
    status: [],
  };

  const { fields, payload, setPayload, setFilterResetFunc } = props;

  const { autoSearchNasGroup, nasGroupAutoSearchResults, isLoadingAutoSearch } = useNasGroup();

  const [nasGroupPayload, setNasGroupPayload] = useState(currentPayload);
  const [nasGroupOptions, setNasGroupOptions] = useState([]);
  const [statusMultiValue, setStatusMultiValue] = useState(false);

  const [nasGroupMultiValue, setNasGroupMultiValue] = useState(false);
  const [defaultNasGroup, setDefaultNasGroup] = useState([]);
  const [defaultStatus, setDefaultStatus] = useState([]);

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const nasGroupOpValue = watch("nasGroupOperator");
  const statusOpValue = watch("statusOperator");

  const onSubmit = async (data) => {
    try {
      let filters = [];

      if (data.nasGroupName != null && Object.keys(data.nasGroupName).length != 0) {
        filters.push({
          fieldName: "nasGroupId",
          fieldValue: convertedValue(data.nasGroupName, "value").join(","),
          op: data.nasGroupNameOperator,
          dataType: "int",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.status != "" && data.status != null) {
        filters.push({
          fieldName: "status",
          fieldValue: convertedValue(data.status, "value").join(","),
          op: data.statusOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  useEffect(() => {
    if (nasGroupOpValue == "in" || nasGroupOpValue == "nin") {
      setDefaultNasGroup([]);
      setValue("nasGroupName", []);
      setNasGroupMultiValue(true);
    } else {
      setDefaultNasGroup({});
      setValue("nasGroupNae", {});
      setNasGroupMultiValue(false);
    }
  }, [nasGroupOpValue]);

  useEffect(() => {
    if (statusOpValue == "in" || statusOpValue == "nin") {
      setDefaultStatus([]);
      setValue("status", []);
      setStatusMultiValue(true);
    } else {
      setDefaultStatus({});
      setValue("status", {});
      setStatusMultiValue(false);
    }
  }, [statusOpValue]);

  const fetchNasGroup = async () => {
    await autoSearchNasGroup(nasGroupPayload);
  };
  useEffect(() => {
    fetchNasGroup();
  }, [nasGroupPayload]);

  useEffect(() => {
    if (nasGroupAutoSearchResults.data.length !== 0) {
      setNasGroupOptions([...nasGroupOptions, ...nasGroupAutoSearchResults.data]);
    }
  }, [nasGroupAutoSearchResults]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} pt={8}>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={6}>
              <ReactHookFormSelect
                name="nasGroupNameOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={6}>
              <SearchableAutoComplete
                control={control}
                data={nasGroupOptions}
                label="Nas Group Name"
                payload={nasGroupPayload}
                setPayload={setNasGroupPayload}
                loading={isLoadingAutoSearch}
                name="nasGroupName"
                multiple={nasGroupMultiValue}
                defaultValue={defaultNasGroup}
              />
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={6}>
              <ReactHookFormSelect
                name="statusOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={6}>
              <SearchableAutoComplete
                control={control}
                data={statusOptions}
                label="Status"
                payload={null}
                setPayload={null}
                loading={false}
                name="status"
                multiple={statusMultiValue}
                defaultValue={defaultStatus}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={reset} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
